import Incubation from "./incubation";

export default Incubation;
